module.exports = __webpack_public_path__ + "img/trip_sendai18.5eda65ae.jpg";